'use client'

import Cookies from 'js-cookie'

import { STORAGE_TOKEN_KEY } from '../constants'

export let localToken = typeof window !== 'undefined' ? Cookies.get(STORAGE_TOKEN_KEY) : null

export function updateLocalToken(token: string) {
  localToken = token
}